import React, { useState } from 'react'

import classNames from 'classnames'

import { FollowDeleteIcon } from '@local/assets/icons'

import { useModal } from '@web/components/Modal/useModal'
import { UseFollowMethods_OtherFragment } from '@web/gql/graphql'
import useFollowMethods from '@web/hooks/useFollowMethods'
import useMe from '@web/hooks/useMe'
import nClicks from '@web/libs/nlog/click/codes'

import Clickable from './Clickable'
import styles from './FollowAcceptOrRejectButton.module.scss'
import Alert from './Modal/Alert'

interface Props {
  user: UseFollowMethods_OtherFragment
  onCompleteDelete?(): void
  onCompleteAccept?(): void
}

const FollowAcceptOrRejectButton = ({ user, onCompleteDelete, onCompleteAccept }: Props) => {
  const { me } = useMe()
  const { acceptFollowRequest, rejectFollowRequest } = useFollowMethods()

  const [accepted, setAccepted] = useState(false)

  const onClickAccept = async () => {
    setAccepted(true)
    acceptFollowRequest(user, onCompleteAccept)
  }

  const onClickDelete = async () => {
    rejectFollowRequest(user, onCompleteDelete)
  }

  const { openModal: openWelcomeAcceptModal } = useModal(Alert, {
    label: {
      confirm: '확인',
      cancel: '취소',
    },
    title: (
      <>
        첫 번째 팔로우 수락이시네요!
        <br />
        팔로우 수락에 대해 확인해 주세요.
      </>
    ),
    subMessage: (
      <>
        내가 팔로우한 사람이 쓴 음식점, 카페, 나들이/여행 가볼 만한 곳의 최신 리뷰를 MY플레이스에서 받아 보실 수
        있습니다.
        <br />
        또한, 팔로우한 사람(팔로잉)과 나를 팔로우한 사람(팔로워) 목록은 누구나 볼 수 있게 공개됩니다.
        <br />
        <br />
        확인을 누르면 팔로우가 진행됩니다.
      </>
    ),
    hasUnderline: true,
    callback: {
      confirm: () => onClickAccept(),
    },
  })

  return accepted ? (
    <span className={styles.accepted}>수락완료</span>
  ) : (
    <>
      <Clickable
        className={classNames(styles.btn, styles.type_accept)}
        onClick={me?.stat.followerCount === 0 ? () => openWelcomeAcceptModal() : onClickAccept}
        nClickCode={nClicks.followListMy.REQOK}
      >
        수락
      </Clickable>
      <Clickable
        className={classNames(styles.btn, styles.type_delete)}
        onClick={onClickDelete}
        nClickCode={nClicks.followListMy.REQDELETE}
      >
        <FollowDeleteIcon className={styles.icon} aria-hidden="true" />
        <span className="place_blind">삭제</span>
      </Clickable>
    </>
  )
}

export default FollowAcceptOrRejectButton
